var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 382,
    viewBox: "0 0 273 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_i_589_3092)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 381.153,
    fill: "#38455A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_3092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.974 206.544L136.704 236.804L74.4333 206.544L80.8037 200.015L87.0148 193.804L93.3852 187.433L136.704 144.115L180.022 187.433L186.393 193.804L192.604 200.015L198.974 206.544Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.604 200.015L136.704 227.248L80.8037 200.015L87.0148 193.804L93.3852 187.433L136.704 144.115L180.022 187.433L186.393 193.804L192.604 200.015Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.393 193.804L136.704 217.852L87.0148 193.804L93.3851 187.433L136.704 144.115L180.022 187.433L186.393 193.804Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.022 187.433L136.704 208.456L93.3852 187.433L99.5963 181.222L136.704 144.115L173.811 181.222L180.022 187.433Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.811 181.222L136.704 199.219L99.5963 181.222L136.704 144.115L173.811 181.222Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.759 175.17L136.704 190.141L105.648 175.17L136.704 144.115L167.759 175.17Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.548 168.959L136.704 180.904L111.859 168.959L136.704 144.115L161.548 168.959Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.337 162.748L136.704 171.826L118.07 162.748L136.704 144.115L155.337 162.748Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.126 156.537L136.704 162.589L124.281 156.537L136.704 144.115L149.126 156.537Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7926 214.507L96.2518 207.341",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.922 211.959L111.381 204.952",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.393 199.219L104.852 192.211",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.248 196.511L118.707 189.504",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.637 179.63L121.096 172.463",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.918 166.252L129.378 158.448",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.848 229L127.307 221.833",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.259 167.844L150.4 174.374",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.859 182.018L159.159 187.593",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.833 192.53L155.656 199.059",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.033 184.248L173.493 190.937",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.256 195.237L168.556 201.13",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.311 210.844L155.496 218.011",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.474 198.263L181.933 204.952",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.193 210.844L173.811 218.967",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.033 206.385L129.219 194.441C126.83 192.37 125.396 189.344 125.396 185.841C125.396 179.47 130.493 174.374 136.863 174.374C143.233 174.374 148.33 179.47 148.33 185.841C148.33 189.185 146.896 192.211 144.507 194.441L147.693 206.385H126.033Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.174 203.2L132.722 193.485L131.289 192.211C129.537 190.619 128.581 188.389 128.581 186C128.581 181.381 132.244 177.719 136.863 177.719C141.481 177.719 145.144 181.381 145.144 186C145.144 188.389 144.189 190.619 142.437 192.211L141.004 193.485L143.552 203.2H130.174Z",
    fill: "#273141",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.156 200.015L136.226 192.37L133.359 189.822C132.244 188.867 131.607 187.433 131.607 186C131.607 183.133 133.996 180.904 136.704 180.904C139.57 180.904 141.959 183.293 141.959 186C141.959 187.433 141.322 188.867 140.207 189.822L137.341 192.37L139.411 200.015H134.156Z",
    fill: "#141F2F",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.704 144.115V236.804",
    stroke: "#141F2F",
    strokeWidth: 1.59259,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_589_3092",
    x: 0,
    y: 0,
    width: 273,
    height: 385.153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_589_3092"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_3092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.407,
    height: 94.6,
    fill: "white",
    transform: "translate(73 143)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDrop);
export default __webpack_public_path__ + "static/media/card-drop.d8b9ab19ee4013a7042c2483f83b2d83.svg";
export { ForwardRef as ReactComponent };